import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsStaffPayments(companyId, query) {
  return dataTransferWrap(
    ModulesMap.REPORTS_STAFF_PAYMENTS,dtConfig[ModulesMap.REPORTS_STAFF_PAYMENTS].getReportsStaffPayments,
    {
      urlParams: {
        companyId
      },
      params: query,
    },
  )
}
function getReportsStaffPayment(companyId, staffPaymentId, query) {
  return dataTransferWrap(ModulesMap.REPORTS_STAFF_PAYMENTS,dtConfig[ModulesMap.REPORTS_STAFF_PAYMENTS].getReportsStaffPayment,
    {
      urlParams: {
        companyId, staffPaymentId
      },
      params: query,
    })
}
function getReportsStaffPaymentPreview(companyId, staffPaymentId, query) {
  return dataTransferWrap(ModulesMap.REPORTS_STAFF_PAYMENTS,dtConfig[ModulesMap.REPORTS_STAFF_PAYMENTS].getReportsStaffPaymentPreview,
    {
      urlParams: {
        companyId, staffPaymentId
      },
      params: query,
    })
}

export default {
  getReportsStaffPayments,
  getReportsStaffPayment,
  getReportsStaffPaymentPreview,
}